 $(document).ready(function() {

var expDate = new Date();
  expDate.setTime(expDate.getTime() + (1440 * 60 * 1000)); // Set 1 Day 

   setTimeout(function(){
     if ($.cookie('pop') == null) {
         $('#storyPopup').modal('show');
         $.cookie('pop', '1', {expires: expDate});
     }
   },2000)

 });



